import React from 'react';
import hn_fisher_portrait from '../assets/hn_fisher_portrait.jpg';
import './About.css';

export default function About() {
  return (
    <main id='about-main'>
      <img
        id='about-image'
        src={hn_fisher_portrait}
        alt='author H.N. Fisher'
      />
      <p id='about-p'>
        H.N. Fisher is a sci-fi and fantasy writer residing in Oregon, U.S.A. where old-growth forests and empty high-deserts inspire her twisted, sprawling worlds—because who needs sunshine when you can have existential dread?
        <br />
        <br />
        Her debut novella, Ghost in the Code, is influenced by her love of dystopian and cyberpunk sci-fi mixed in with a dash of nostalgia from living in San Francisco, and a sprinkle of cat mischief.
        <br />
        <br />
        When she’s not busy crafting her next book, you’ll find her hiking, traveling, or enjoying an old-fashioned cocktail on the patio and contemplating the mysteries of life (or just how to keep her potted plants alive).
      </p>
    </main>
  )
}
